<template>
  <div class="bg-white h-screen">
    <div class="bg-lightGray">
      <GradientHeader
        :logo="logo"
        :colour="colours.primary"
      >
        <OffsetColorBox
          :colour="colours.accentPrimary"
          :gray="colours.primaryIsWhite"
          class="max-w-screen-xl mx-auto px-4 md:px-8"
        >
          <template slot="heading">
            <TextSkeleton
              v-if="loading"
              :characters="10"
              :words="5"
              pulse
            />
            <template v-else>{{ heading }}</template>
          </template>
          <template
            v-if="!loading"
            slot="icon"
          >
            <IconCircular
              v-if="type === 'success'"
              class="bg-success"
              :style="`background: ${colours.accentPrimary}`"
            >
              <TickIcon
                class="w-4/5 text-white"
                :style="`color: ${colours.accentSecondary}`"
              />
            </IconCircular>

            <IconCircular
              v-if="type === 'warning'"
              class="bg-warn"
            >
              <ExclamationIcon class="w-4/5" />
            </IconCircular>

            <IconCircular
              v-if="type === 'error'"
              class="bg-error"
            >
              <CrossIcon class="w-4/5" />
            </IconCircular>
          </template>

          <TextSkeleton
            v-if="loading"
            :characters="10"
            :words="30"
            pulse
          />
          <p v-else>
            <strong v-if="messageIntro">{{ messageIntro }}</strong> {{ message }}
          </p>
        </OffsetColorBox>
      </GradientHeader>

      <CtaSection
        v-if="!branding"
        class="max-w-screen-xl mx-auto mt-8 px-12 md:px-16 lg:px-24"
      />
      <div
        v-else
        id="signing-feedback"
        class="py-20"
      />
    </div>

    <div
      v-if="!branding"
      id="signing-feedback"
      class="py-20 bg-white"
    />
  </div>
</template>

<script setup>
// @ts-check
import { computed, defineProps } from 'vue'

import GradientHeader from '@/components/library/GradientHeader.vue'
import OffsetColorBox from '@/components/library/OffsetColorBox.vue'
import CtaSection from '@/components/library/CtaSection.vue'
import TickIcon from '@/components/icons/TickIcon.vue'
import CrossIcon from '@/components/icons/CrossIcon.vue'
import ExclamationIcon from '@/components/icons/ExclamationIcon.vue'
import IconCircular from '@/components/icons/IconCircular.vue'
import TextSkeleton from '@/components/library/closet/TextSkeleton.vue'

const props = defineProps({
  branding: Object,
  heading: {
    type: String,
    required: true
  },
  messageIntro: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    validator: (value) => ['success', 'warning', 'error'].includes(value)
  },
  loading: Boolean
})

const colours = computed(() => props.branding ? props.branding.colours : {})
const logo = computed(() => props.branding && props.branding.logo)
</script>
